import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Users, Eye, FolderCheck, TrendingUp } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const SocialProofSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });
  const { language } = useLanguage();

  const content = {
    en: {
      overline: 'Proven Results',
      headline: 'Numbers That Speak',
      metrics: [
        { icon: Users, value: '400+', label: 'Clients Worked With' },
        { icon: Eye, value: '5M+', label: 'Content Views' },
        { icon: FolderCheck, value: '600+', label: 'Projects Completed' },
        { icon: TrendingUp, value: '+180%', label: 'Avg. ROI Increase' },
      ],
    },
    tr: {
      overline: 'Kanıtlanmış Sonuçlar',
      headline: 'Konuşan Rakamlar',
      metrics: [
        { icon: Users, value: '400+', label: 'Çalıştığımız Müşteri' },
        { icon: Eye, value: '5M+', label: 'İçerik Görüntülenmesi' },
        { icon: FolderCheck, value: '600+', label: 'Tamamlanan Proje' },
        { icon: TrendingUp, value: '+180%', label: 'Ort. ROI Artışı' },
      ],
    },
  };

  const t = content[language] || content.en;

  return (
    <section className="py-14 md:py-16 bg-[#0A0A0A] relative overflow-hidden" ref={ref}>
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-[#E60000]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-[#E60000]/5 rounded-full blur-3xl" />
      
      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-10"
        >
          <span className="text-[#E60000] text-sm uppercase tracking-[0.2em] font-bold">{t.overline}</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mt-3">
            {t.headline}
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {t.metrics.map((metric, index) => (
            <motion.div
              key={metric.label}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="text-center"
              data-testid={`metric-${index}`}
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-white/5 border border-white/10 mb-3">
                <metric.icon className="w-5 h-5 text-[#E60000]" />
              </div>
              <p className="font-heading text-3xl md:text-4xl font-black text-white mb-1">
                {metric.value}
              </p>
              <p className="text-gray-400 text-sm">{metric.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
